import React from 'react';
import styled from 'styled-components';

import Breakpoint from '../../utils/breakpoints';
import { media } from '../../utils/style-utils';
import LoginButtons from './login-buttons/LoginButtons';
import LoginCustomers from './login-customers/LoginCustomers';
import LoginWhyNitro from './login-why-nitro/LoginWhyNitro';
import LoginDemo from './login-demo/LoginDemo';
import LoginHero from './login-hero/LoginHero';
import BackgroundBlueDesktop from '../../assets/images/login/blue_bg_desktop.svg';
import BackgroundBlueMobile from '../../assets/images/login/blue_bg_mobile.svg';
import FormBlueDesktop from '../../assets/images/login/form_bg_desktop.svg';
import FormBlueMobile from '../../assets/images/login/form_bg_mobile.svg';

const Container = styled.div`
  position: relative;
  background: white;
  z-index: 0;
`;

const BlueBackground = styled.div`
  position: relative;
  padding-bottom: 200px;

  ${media.mobile`
    margin-bottom: 60px;
  `};

  ${media.tablet`
    margin-bottom: 60px;
  `};
`;

const BackgroundImg = styled.img`
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 100%;
`;

const LoginDemoWrapper = styled.div`
  margin-top: 60px;
  display: flex;
  justify-content: center;
  padding: 36px;
  background-size: cover;
  background-image: url(${FormBlueDesktop});

  ${media.mobile`
    width: 100%;
    background-image: url(${FormBlueMobile});
  `};

  ${media.tablet`
    width: 100%;
    background-image: url(${FormBlueDesktop});
  `};
`;

const WHY_NITRO_EL_ID = 'login-why-nitro';
const DEMO_EL_ID = 'login-demo';

class Login extends React.Component {
  render() {
    return (
      <Container>
        <BlueBackground>
          <Breakpoint name="tabletDesktop">
            <BackgroundImg src={BackgroundBlueDesktop} />
          </Breakpoint>
          <Breakpoint name="mobile">
            <BackgroundImg src={BackgroundBlueMobile} />
          </Breakpoint>
          <LoginButtons whyNitroElId={WHY_NITRO_EL_ID} demoElId={DEMO_EL_ID} />

          <LoginHero demoElId={DEMO_EL_ID} />
        </BlueBackground>
        <LoginCustomers />
        <LoginWhyNitro id={WHY_NITRO_EL_ID} />
        <LoginDemoWrapper id={DEMO_EL_ID}>
          <LoginDemo />
        </LoginDemoWrapper>
      </Container>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/features/login/Login.js